import React from "react";
import { TRUST_FOOTER_LINKS } from "./trustContent";

/**
 * Phone-only: compact end-of-scroll legal links (no long disclaimer / attribution block).
 */
export default function MobilePageFooter({ onNavigate }) {
  return (
    <footer className="v2-mobile-page-footer" role="contentinfo">
      <nav className="v2-mobile-page-footer__nav" aria-label="Legal and about">
        {TRUST_FOOTER_LINKS.map((link) => (
          <button
            key={link.id}
            type="button"
            className="v2-mobile-page-footer__link"
            onClick={() => onNavigate?.(link.id)}
          >
            {link.label}
          </button>
        ))}
      </nav>
    </footer>
  );
}
